import * as Yup from "yup";
import PhoneNumberUtil from "../../../../../utils/phone-number-util";
import parsePhoneNumber from "libphonenumber-js";
import { parsePhoneNumberWithError, ParseError } from "libphonenumber-js";

export const formValidationSchema = ({ t }) => {
  return Yup.object().shape({
    name: Yup.string().required(
      t("errors.formRequiredField", { fieldName: t("common.yourName") })
    ),
    phoneNumber: Yup.string()
      .required(
        t("errors.formRequiredField", { fieldName: t("common.phoneNumber") })
      )
      .test({
        test: (value) => {
          const phoneNumber = parsePhoneNumber(value);
          if (phoneNumber) {
            return PhoneNumberUtil.validateForCountry(
              phoneNumber.nationalNumber,
              phoneNumber.country
            );
          } else {
            return true;
          }
        },
        message: t("errors.invalidFieldValue", {
          fieldName: t("common.phoneNumber"),
        }),
      })
      .test({
        test: (value) => {
          try {
            const phoneNumber = parsePhoneNumberWithError(value);
            if (phoneNumber) {
              return true;
            }
          } catch (error) {
            if (error instanceof ParseError && error.message === "TOO_SHORT") {
              return false;
            } else {
              return true;
            }
          }
        },
        message: t("errors.formFieldTooShort", {
          fieldName: t("common.phoneNumber"),
        }),
      }),
    email: Yup.string()
      .optional()
      .matches(
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
        t("errors.invalidFieldValue", { fieldName: t("common.email") })
      ),
  });
};
